import type { PublisherEventFeedItem } from "../types";

function safeGameLabel(e: PublisherEventFeedItem): string {
  return e.game_name ?? (e.appid != null ? `App ${e.appid}` : "Game");
}

export function getPublisherEventLabel(eventType: string): string {
  switch (eventType) {
    case "publisher_ccu_enter":
      return "CCU chart entry";
    case "publisher_ccu_peak":
      return "CCU peak";
    case "wishlist_peak":
      return "Wishlist rank peak";
    case "topseller_enter":
      return "Top Sellers entry";
    case "topseller_peak":
      return "Top Sellers peak";
    case "ccu_peak":
      return "CCU peak";
    default:
      // Fallback: turn snake_case into Title Case
      return eventType
        .split("_")
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
  }
}

export type PublisherEventTone = "wishlist" | "topsellers" | "ccu" | "default";

export function getPublisherEventTone(eventType: string): PublisherEventTone {
  switch (eventType) {
    case "wishlist_peak":
      return "wishlist";
    case "topseller_enter":
    case "topseller_peak":
      return "topsellers";
    case "ccu_peak":
    case "publisher_ccu_enter":
    case "publisher_ccu_peak":
      return "ccu";
    default:
      return "default";
  }
}

export function formatPublisherEventText(e: PublisherEventFeedItem): string {
  const game = safeGameLabel(e);
  const value = e.value;
  const prev = e.prev_value;

  switch (e.event_type) {
    case "publisher_ccu_peak":
      return `Publisher reached a new CCU peak: ${value ?? "—"}`;
    case "publisher_ccu_enter":
      return `Publisher entered CCU chart: ${value ?? "—"}`;
    case "wishlist_peak":
      return `Game ${game} reached a new Wishlist rank peak: #${value ?? "—"}`;
    case "topseller_enter":
      return `Game ${game} entered Global Top Sellers${
        value != null ? ` at #${value}` : ""
      }`;
    case "topseller_peak":
      return `Game ${game} reached a new Top Sellers peak: #${value ?? "—"}`;
    case "ccu_peak":
      if (e.appid == null) {
        return `Publisher reached a new CCU peak: ${value ?? "—"}`;
      }
      return `Game ${game} reached a new CCU peak: ${value ?? "—"}`;
    default: {
      const scope = e.appid == null ? "Publisher" : `Game ${game}`;
      if (value == null && prev == null) {
        return `${scope}: ${getPublisherEventLabel(e.event_type)}`;
      }
      if (prev == null) {
        return `${scope}: ${getPublisherEventLabel(e.event_type)} (${
          value ?? "—"
        })`;
      }
      return `${scope}: ${getPublisherEventLabel(e.event_type)} (${
        value ?? "—"
      }, prev: ${prev})`;
    }
  }
}
